import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';

import { useEffect, useState } from 'react';
import s from './styles/factor.module.scss';
import FactorItem from './components/FactorItem';
import FactorCard from './components/FactorCard';
import { getSearchStr } from '@/utils/Page';
const searchStr = getSearchStr();
const Factor = (props) => {
    let { navigate, params } = props;
    let { agentId, caseId, sceneId } = params;
    const { simulation } = props.store;

    let { curSection, sections, setCurSection, setPreSection, preSection, handleChangeCurSection, isFading, verifyLogin } = simulation;
    const goRoleIntroduce = async () => {
        let res = await verifyLogin();
        if (!res) {
            return;
        }
        navigate(`/web/o/${agentId}/simulation/${caseId}/${sceneId}/role-introduce${searchStr}`, { replace: true });
    };
    return (
        <>
            <div className={s['factor-box']}>
                <FactorItem
                    goRoleIntroduce={goRoleIntroduce}
                    isFading={isFading}
                    handleChangeCurSection={handleChangeCurSection}
                    sections={sections}
                    preSection={preSection}
                    setCurSection={setCurSection}
                    curSection={curSection}
                    setPreSection={setPreSection}
                ></FactorItem>
                <FactorCard
                    handleChangeCurSection={handleChangeCurSection}
                    curData={curSection}
                    setCurSection={setCurSection}
                    sections={sections}
                ></FactorCard>
            </div>
        </>
    );
};
export default withRouter(inject('store')(observer(Factor)));
